import { combineReducers } from 'redux';

import widgets from './widgets/reducer';
import list from './list/reducer';
import paging from './paging/reducer';
import feedQuestionnaires from './feedQuestionnaires/reducer';
import feedQuestions from './feedQuestions/reducer';

export default combineReducers({
  list,
  paging,
  widgets,
  feedQuestionnaires,
  feedQuestions
});





/** WEBPACK FOOTER **
 ** ./src/members/state/feed/reducer.js
 **/